// src/hooks/useT.js

import { useTranslation } from "react-i18next";
import i18n from "i18next";

const useT = () => {
  const { t, i18n } = useTranslation();

  const translate = (key, options = {}) => {
    if (!i18n.exists(key)) {
      console.warn("Missing translation:", key);
    }

    return t(key, {
      defaultValue: key,
      ...options,
    });
  };

  return {
    t: translate,
    lang: i18n.language,
  };
};

export const translateStatic = (key, options = {}) => {
  if (i18n?.exists && !i18n.exists(key)) {
    console.warn("Missing translation:", key);
  }

  return i18n.t(key, {
    defaultValue: key,
    ...options,
  });
};

export default useT;
